function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 12 15"
}, props), React.createElement("path", {
  d: "M7.248 14.534a1.215 1.215 0 01-.962.466 1.215 1.215 0 01-.91-.409L1.016 9.75a1.206 1.206 0 01.099-1.707 1.213 1.213 0 011.708.081l2.248 2.497V1.803c0-.664.54-1.203 1.215-1.203.671 0 1.215.547 1.215 1.203v8.818L9.75 8.124c.44-.49 1.209-.53 1.708-.08.502.451.542 1.212.097 1.706l-4.307 4.784z",
  fill: "#969EA2"
})));